import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import BentoGallery from './components/BentoGallery';
import VideoShowcase from './components/VideoShowcase';
import Footer from './components/Footer';
import AboutUs from './pages/AboutUs';
import PameBrosta from './pages/PameBrosta';
import OlympicAngels from './pages/OlympicAngels';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <HeroSection />
              <BentoGallery />
              <VideoShowcase />
              <Footer />
            </>
          } />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/pame-brosta" element={<PameBrosta />} />
          <Route path="/olympic-angels" element={<OlympicAngels />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
